import React from 'react';
import styled from 'styled-components';
import { SvgWrapper } from '../svg-wrapper';
var Svg = /*#__PURE__*/styled(SvgWrapper).withConfig({
  displayName: "star-on-icon__Svg",
  componentId: "hzofqg-0"
})(["width:40px;height:40px;color:", ";"], p => p.theme.colors.primary500);
export var StarOn = (_ref) => {
  var {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(Svg, {
    viewBox: "0 0 40 40",
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    fillRule: "nonzero",
    points: "20 27.9973049 8.25735421 36 12.269322 22.4024194 1 13.7507764 15.2221782 13.3497045 20 0 24.7778218 13.3497045 39 13.7507764 27.730678 22.4024194 31.7426458 36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "40",
    height: "40"
  })));
};